import ContentWrapper from '../common/ContentWrapper';
import Doodle from './Doodle';
import BaseAccountCard from './BaseAccountCard';
import type FooterType from '../../../types/Footer';
import PageLayout from '../common/PageLayout';

type BaseAccountPageProps = {
  children: React.ReactNode;
  showDoodle?: boolean;
  footer?: FooterType;
};

const BaseAccountPage = ({ children, showDoodle = true, footer }: BaseAccountPageProps) => {
  return (
    <PageLayout
      footer={{
        content: footer,
        mini: true,
      }}
    >
      <main className="flex grow flex-col bg-red-100 sm:block sm:pb-12">
        <ContentWrapper className="mx-0 h-screen justify-around sm:mx-auto sm:flex sm:h-full sm:pt-14 sm-max:px-0">
          {showDoodle && <Doodle className="hidden lg:flex" />}
          <BaseAccountCard>{children}</BaseAccountCard>
        </ContentWrapper>
      </main>
    </PageLayout>
  );
};

export default BaseAccountPage;
